import { createSelector } from "reselect";

const broker = (state: any) => state.brokerReducer;

export const getAllBrokers = createSelector(broker, (broker) => {
  return broker.brokersFull;
});
